import { render } from "./HistorialTraspasos.vue?vue&type=template&id=1fe2a4d8&scoped=true"
import script from "./HistorialTraspasos.vue?vue&type=script&lang=js"
export * from "./HistorialTraspasos.vue?vue&type=script&lang=js"

import "./HistorialTraspasos.vue?vue&type=style&index=0&id=1fe2a4d8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2a4d8"]])

export default __exports__